/**
 * Mapa único de role → rota de dashboard. Usado em Auth.jsx, AuthCallback.jsx
 * (Google login), Layout header ("Meu painel") e qualquer outro lugar que
 * precise levar o usuário direto pra sua área depois de login/registro.
 *
 * Regra:
 *  - admin        → /admin
 *  - consultor    → /consultor
 *  - profissional → /profissional
 *  - clinica      → /clinica
 *  - familia      → /meus-atendimentos (não tem "dashboard" — tem lista de casos)
 *  - qualquer outro (desconhecido) → /
 */
export const dashboardPathForRole = (role) => {
  switch (role) {
    case "admin":         return "/admin";
    case "consultor":     return "/consultor";
    case "profissional":  return "/profissional";
    case "clinica":       return "/clinica";
    case "familia":       return "/meus-atendimentos";
    default:              return "/";
  }
};
